import React from "react";
import {Box, Typography} from "@mui/material";

import {IconSeeker} from "@ui-seeker/core";
import {monitoringAdminReportDetails} from "../../@signals";


export default function nameColumn(value, label, showDetails=false) {
    return {
        name: value, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => <Box>
                <Typography variant={'subtitle2'} sx={{ mb: 1 }}>{value}</Typography>
                {!!showDetails && <Box
                    onClick={() => monitoringAdminReportDetails.value = row}
                    display='flex'
                    justifyContent='center'
                    alignItems='baseline'
                >
                    <IconSeeker icon="circle-info"/>
                    <Typography variant={'body2'} sx={{ ml: .4, "&:hover": { textDecoration: 'underline' } }}>
                        View Details
                    </Typography>
                </Box>}
            </Box>
        }
    }
}